import { gql } from "@apollo/client";
import { globalLensFragmentV2 } from "../fragments";

export const getLensListV2 = gql`
    query getLensListV2(
        $limit: Int!
        $cursor: String!
        $organizationId: String = null
        $lensSourceIds: [String!] = []
    ) {
        selectedOrganization @client {
            id @export(as: "organizationId")
        }
        getLensListV2(
            input: { limit: $limit, cursor: $cursor, organizationId: $organizationId, lensSourceIds: $lensSourceIds }
        ) {
            lensesWithConnections {
                ...GlobalLensFragmentV2
            }
            cursor
            hasMore
        }
    }
    ${globalLensFragmentV2}
`;
